/**
 * RTWO Cryptography & Identity Engine — Crypto Utilities
 */

export function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export function hexToBytes(hex: string): Uint8Array {
  const normalized = hex.startsWith('0x') ? hex.slice(2) : hex;
  if (normalized.length % 2 !== 0) {
    throw new Error('Invalid hex string length.');
  }

  const bytes = new Uint8Array(normalized.length / 2);
  for (let index = 0; index < bytes.length; index++) {
    bytes[index] = parseInt(normalized.slice(index * 2, index * 2 + 2), 16);
  }
  return bytes;
}

export function isValidHex(value: string): boolean {
  const normalized = value.startsWith('0x') ? value.slice(2) : value;
  return normalized.length > 0 && /^[0-9a-fA-F]+$/.test(normalized);
}

export function createKeyPairId(): string {
  return `keypair-${crypto.randomUUID()}`;
}

export function createSignatureId(): string {
  return `sig-${crypto.randomUUID()}`;
}

export function createPrivateKeyReference(keyPairId: string): string {
  return `privref-${keyPairId}`;
}
